export type { ApitallyConfig, ApitallyConsumer } from "../common/types.js";
export { default as apitallyPlugin, setConsumer } from "./plugin.js";
